var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4 24H20.5652V15.563C20.5652 13.3547 19.6526 11.8471 17.6455 11.8471C16.1104 11.8471 15.2567 12.8644 14.8593 13.8449C14.7103 14.1968 14.7336 14.6871 14.7336 15.1773V24H8.95316C8.95316 24 9.02767 9.05475 8.95316 7.69623H14.7336V10.255C15.0751 9.13621 16.9222 7.53948 19.8698 7.53948C23.5268 7.53948 26.4 9.88462 26.4 14.9345V24ZM3.10752 5.65692H3.07028C1.20762 5.65692 0 4.41057 0 2.83076C0 1.2202 1.24332 0 3.14323 0C5.04158 0 6.20884 1.21714 6.24609 2.82616C6.24609 4.40598 5.04157 5.65692 3.10752 5.65692ZM0.665881 7.69623H5.81147V24H0.665881V7.69623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.babf656c311de3a21b3a6e8b06ca0346.svg";
export { ForwardRef as ReactComponent };